import fontHindVadodaraLightEot from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-Light.eot';
import fontHindVadodaraLightTtf from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-Light.ttf';
import fontHindVadodaraLightWoff from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-Light.woff';
import fontHindVadodaraLightWoff2 from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-Light.woff2';
import fontHindVadodaraMediumEot from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-Medium.eot';
import fontHindVadodaraMediumTtf from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-Medium.ttf';
import fontHindVadodaraMediumWoff from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-Medium.woff';
import fontHindVadodaraMediumWoff2 from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-Medium.woff2';
import fontHindVadodaraRegularEot from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-Regular.eot';
import fontHindVadodaraRegularTtf from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-Regular.ttf';
import fontHindVadodaraRegularWoff from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-Regular.woff';
import fontHindVadodaraRegularWoff2 from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-Regular.woff2';
import fontHindVadodaraSemiBoldEot from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-SemiBold.eot';
import fontHindVadodaraSemiBoldTtf from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-SemiBold.ttf';
import fontHindVadodaraSemiBoldWoff from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-SemiBold.woff';
import fontHindVadodaraSemiBoldWoff2 from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-SemiBold.woff2';
import fontHindVadodaraBoldEot from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-Bold.eot';
import fontHindVadodaraBoldTtf from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-Bold.ttf';
import fontHindVadodaraBoldWoff from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-Bold.woff';
import fontHindVadodaraBoldWoff2 from '../../../../../assets/fonts/Hind_Vadodara/HindVadodara-Bold.woff2';
export const fontFamilyPrimary = `
          @font-face {
            font-display: swap;
            font-weight: 300;
            font-style: normal;
            font-family: 'Hind Vadodara';
            src: local('Hind Vadodara'),
                url('${fontHindVadodaraLightEot}?#iefix') format('embedded-opentype'),
                url('${fontHindVadodaraLightWoff2}') format('woff2'),
                url('${fontHindVadodaraLightWoff}') format('woff'),
                url('${fontHindVadodaraLightTtf}') format('truetype');
          }
          
          @font-face {
            font-display: swap;
            font-weight: 500;
            font-style: normal;
            font-family: 'Hind Vadodara';
            src: local('Hind Vadodara'),
                url('${fontHindVadodaraMediumEot}?#iefix') format('embedded-opentype'),
                url('${fontHindVadodaraMediumWoff2}') format('woff2'),
                url('${fontHindVadodaraMediumWoff}') format('woff'),
                url('${fontHindVadodaraMediumTtf}') format('truetype');
          }

          @font-face {
            font-display: swap;
            font-weight: normal;
            font-style: normal;
            font-family: 'Hind Vadodara';
            src: local('Hind Vadodara'),
                 url('${fontHindVadodaraRegularEot}?#iefix') format('embedded-opentype'),
                 url('${fontHindVadodaraRegularWoff2}') format('woff2'),
                 url('${fontHindVadodaraRegularWoff}') format('woff'),
                 url('${fontHindVadodaraRegularTtf}') format('truetype');
          }
          
          @font-face {
            font-display: swap;
            font-weight: 600;
            font-style: normal;
            font-family: 'Hind Vadodara';
            src: local('Hind Vadodara'),
                url('${fontHindVadodaraSemiBoldEot}?#iefix') format('embedded-opentype'),
                url('${fontHindVadodaraSemiBoldWoff2}') format('woff2'),
                url('${fontHindVadodaraSemiBoldWoff}') format('woff'),
                url('${fontHindVadodaraSemiBoldTtf}') format('truetype');
          }
          
          @font-face {
            font-display: swap;
            font-weight: bold;
            font-style: normal;
            font-family: 'Hind Vadodara';
            src: local('Hind Vadodara'),
                url('${fontHindVadodaraBoldEot}?#iefix') format('embedded-opentype'),
                url('${fontHindVadodaraBoldWoff2}') format('woff2'),
                url('${fontHindVadodaraBoldWoff}') format('woff'),
                url('${fontHindVadodaraBoldTtf}') format('truetype');
          }
`;
